export default {
    "DEFAULT": {
        seq: [
        ],
    },
    "SAMARITANS": {
        availableKeys: ["cdssempty"]
    }

}